/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AddressResultType = {
    Unknown: 'Unknown',
    Address: 'Address',
    AccessAddress: 'AccessAddress',
    Street: 'Street',
    StreetPostalCode: 'StreetPostalCode',
} as const;
export type AddressResultType = typeof AddressResultType[keyof typeof AddressResultType];

